export const LANDING = '/'
export const SIGN_IN = '/signin'
export const SIGN_UP = '/signup'

export const ACCOUNT = '/account'
export const DASHBOARD = '/dashboard'
export const DASHBOARD_SOLO = '/solo-dashboard'
export const DASHBOARD_MULTI = '/multi-dashboard'
export const ORDERS = '/orders'

export const ADMIN = '/admin'

export const DEVTOOLS = {
  get INDEX() { return '/devtools' },
  get FONTS() { return this.INDEX + '/fonts' },
  get API()   { return this.INDEX + '/api' },
}

export const BASKET = {
  get INDEX()           { return '/basket' },
  get PAYMENT_METHOD()  { return this.INDEX + '/payment-method' },
  get CHECKOUT()        { return this.INDEX + '/checkout' },
}



// WEBPACK FOOTER //
// ./src/pages/routes.ts